import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserLocationService {

  private selLocationIdSubject = new BehaviorSubject<string | null>(null);
  selLocationId$ = this.selLocationIdSubject.asObservable();   // Expose an observable of the location ID
  private selLocationNameSubject = new BehaviorSubject<string | null>(null);
  selLocationName$ = this.selLocationNameSubject.asObservable(); 
  private locationIdSubject = new BehaviorSubject<string | null>(null);
  locationId$ = this.locationIdSubject.asObservable();   // Expose an observable of the location ID
  private locationData: Array<{ locationId: string; locationName: string }> = [];

  constructor() {
    if (this.isLocalStorageAvailable()) {
      // On service initialization, check if locationData and locationId exist in localStorage
      const storedLocationData = sessionStorage.getItem('userLocationData');
      const storedLocationId = sessionStorage.getItem('userLocationId');

      if (storedLocationData) {
        this.locationData = JSON.parse(storedLocationData);
      }

      if (storedLocationId) {
        this.setLocationId(storedLocationId);
      }
    }
  }

  private isLocalStorageAvailable(): boolean {
    return typeof window !== 'undefined' && !!window.localStorage;
  }

  // Method to set location data
  setLocationData(data: any[]) {
    this.locationData = data;
    // Store the entire location data in localStorage
    sessionStorage.setItem('userLocationData', JSON.stringify(data));
    
    // If data exists and contains at least one item, set the default locationId
    if (data && data.length > 0) {
      this.setLocationId(data[0].locationId);
    }
    // Find the location where baseLocation is true
    const baseLocation = data.find((loc) => loc.baseLocation === true);
    if (baseLocation) {
      sessionStorage.setItem('baseLocationId', baseLocation.locationId);
    }
  }

  // Method to get location data
  getLocationData() {
    
    if (this.isLocalStorageAvailable()) {
      const storedData = sessionStorage.getItem('userLocationData');
      return storedData ? JSON.parse(storedData) : null;
    }
    else {
      return null
    }
  }

  // Clear location data
  clearLocationData() { this.locationData = [] }

  // Method to set the location ID (e.g., on login)
  setLocationId(locationId: string) {
    this.locationIdSubject.next(locationId);
    sessionStorage.setItem('userLocationId', locationId); // Persist to localStorage
  }

  // Method to clear the location ID (e.g., on logout)
  clearLocationId() {
    this.locationIdSubject.next(null);
    sessionStorage.removeItem('userLocationId'); // Clear from localStorage
  }

  // Method to set the selected location ID (e.g., on login)
  setSelLocationId(locationId: string) {
  this.selLocationIdSubject.next(locationId);
  sessionStorage.setItem('selLocationId', locationId); // Persist to localStorage
  }

  getSelLocationId(): string | null {
    let locAvl = typeof window !== 'undefined' && !!window.localStorage;
    if (locAvl) {
      let selLocationId: any = sessionStorage.getItem('selLocationId');
      return selLocationId;
    }
    return null
  }

  // Method to clear the selected location ID (e.g., on logout)
  clearSelLocationId() {
    this.selLocationIdSubject.next(null);
    sessionStorage.removeItem('selLocationId'); // Clear from localStorage
  }

   // Method to set the selected location ID (e.g., on login)
  setSelLocationName(locationName: string) {
  this.selLocationNameSubject.next(locationName);
  sessionStorage.setItem('selLocationName', locationName); // Persist to localStorage
  }

  getSelLocationName(): string | null {
    let locAvl = typeof window !== 'undefined' && !!window.localStorage;
    if (locAvl) {
      let selLocationName: any = sessionStorage.getItem('selLocationName');
      return selLocationName;
    }
    return null
  }

  // Method to clear the selected location ID (e.g., on logout)
  clearSelLocationName() {
    this.selLocationNameSubject.next(null);
    sessionStorage.removeItem('selLocationName'); // Clear from localStorage
  }

  getSelectedLocation(): string | null {
    let locationId =  this.locationIdSubject.getValue();
    return locationId ? locationId : null
  }

  // Method to get the current location ID value
  getLocationIds(): string | null {
    return this.locationIdSubject.getValue();
  }
}
